<script lang="ts" setup>
import { A11y, Pagination } from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'
import SwiperCore from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

const props = defineProps<{
  images: ProductTileImage[]
  isPriorityImages: boolean
  sizes: string
}>()
const swiperUtils = ref<SwiperCore | null>(null)
const lazyPreloadPrevNext = ref(1)

const onSwiper = (swiper: SwiperCore) => {
  swiperUtils.value = swiper
}

const swiperOptions: SwiperOptions = {
  modules: [A11y, Pagination],
  slidesPerView: 'auto',
  spaceBetween: 4,
  pagination: {
    clickable: true,
  },
  loop: true,
}
const onSlideChange = (swiper: SwiperCore) => {
  lazyPreloadPrevNext.value = swiper.activeIndex + 1
}
</script>
<template>
  <Swiper
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    :modules="swiperOptions.modules"
    :slides-per-view="swiperOptions.slidesPerView"
    :space-between="swiperOptions.spaceBetween"
    :pagination="swiperOptions.pagination as any"
    :loop="swiperOptions.loop"
    :lazy="!isPriorityImages"
    :lazyPreloadPrevNext
    class="product-tile-swiper"
  >
    <SwiperSlide v-for="(image, index) in images" :key="index" class="product-tile-swiper__slide">
      <img
        :loading="isPriorityImages ? 'eager' : 'lazy'"
        :src="image.src"
        :alt="image.alt"
        :sizes="sizes"
        :srcset="image.srcset"
        :fetchPriority="index === 0 ? (isPriorityImages ? 'high' : 'auto') : 'low'"
        class="product-tile-swiper__image"
      />
    </SwiperSlide>
  </Swiper>
</template>

<style lang="postcss">
.product-tile-swiper {
  .swiper-pagination-bullets {
    height: fit-content;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    position: absolute;
    bottom: 0;
    margin-bottom: var(--space-50);
    z-index: 1;
  }

  .swiper-pagination-bullet {
    border: 1px solid var(--ui-neutral-50);
    background: var(--surface-light-00-t40);
    position: relative;
    width: 0.438rem;
    height: 0.438rem;
    border-radius: 50%;
  }

  .swiper-pagination-bullet-active {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--ui-neutral-50);
    width: 0.438rem;
    height: 0.438rem;

    &::after {
      content: '';
      display: block;
      width: 0.438rem;
      height: 0.438rem;
      background: var(--ui-neutral-50);
      border-radius: 50%;
      opacity: 0.6;
    }
  }
  .product-tile-swiper__image {
    aspect-ratio: var(--aspect-ratio-product);
    object-fit: cover;
  }
}
</style>
